import { createContext, useContext } from "react";
import { createFormHookContexts } from "@tanstack/react-form";
import { invariant } from "@searchui-searchforms/shared/utils";
import type { FormAPI } from "../types";

export const { fieldContext, formContext, useFormContext } = createFormHookContexts();

export const FormAPIContext = createContext<null | FormAPI>(null);

export const useFormAPIAdapter = () => {
    const context = useContext(FormAPIContext);

    invariant(context, "useFormAPIAdapter must be used inside a provider");

    return context;
};
